// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider_slider__2ENeE","mover":"slider_mover__37CvA","active":"slider_active__39_6p"};